export const LAYOUT_DIALOG_WIDTH = 620;

export const DOCS_URL = 'https://www.ankr.com/docs/build-blockchain/overview';

export enum Header {
  Default = 'default',
  Sidebar = 'sidebar',
  Mobile = 'mobile',
}

export enum ESettingsNavTab {
  platform,
  swagger,
  general,
  teammates,
  notifications,
}
